import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

export function useListarObjetivosCompras() {
  const fetchData = async () => {
    const LISTAR_OBJETIVOS_COMPRAS = `${leadsWebEnviroment}/mobile/objetivos-compras/v1`;
    const response = await instance.get(LISTAR_OBJETIVOS_COMPRAS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_objetivos_compras"],
    refetchOnMount: true,
    enabled: false,
  });
  return query;
}
